/**
 * seyoul-xpc-skin.js — lớp giao diện cho popup thanh toán của app Express Checkout (.sey-xpc).
 *
 * Nguyên tắc: KHÔNG thay logic của app. File này chỉ:
 *  1. gắn class "sxs" lên gốc popup để seyoul-xpc-skin.css có hiệu lực;
 *  2. thay emoji bằng icon nét (badge, ghi chú gói kín, mã giảm giá, ổ khoá);
 *  3. sắp lại vị trí khối: cột phải = đơn hàng → nút đặt → mốc quà → upsell (như spotless.vn);
 *     điện thoại = thanh tóm tắt thu gọn ở đầu + khung mã giảm giá/tổng ngay trên nút đặt;
 *  4. khối "ข้อเสนอพิเศษสำหรับคุณ": thêm sản phẩm bằng /cart/add.js rồi gọi lại cổng mở
 *     popup của app (click phần tử khớp trigger_selector) → app tự đọc lại /cart.js,
 *     tính lại phí ship, voucher, quà Qikify như khi khách sửa số lượng.
 *
 *  5. BỎ BƯỚC XEM GIỎ: mọi link "/cart" (icon giỏ ở header, nút "ดูตะกร้าสินค้า" trong toast
 *     thêm giỏ, "ดูตะกร้า" trong mini-cart) mở thẳng popup nhập địa chỉ + thanh toán.
 *     Popup đã có danh sách sản phẩm, tăng/giảm, xoá → kiêm luôn vai trò giỏ hàng.
 *     Giỏ trống thì để link đi bình thường tới /cart.
 *
 * Có 2 nguồn popup: app block ([data-sey-xpc]) và section cũ trong theme (.sey-xpc không
 * data-sey-xpc, đang gắn ở trang /cart). App tự nhường khi có section cũ → file này cũng
 * coi section cũ là popup "đang chạy" khi nó có mặt, và skin cả hai.
 *
 * Nút đặt hàng dù ở đâu vẫn là nút của app ([data-xpc-submit] → onSubmit).
 * Node của app chỉ được DI CHUYỂN (giữ nguyên listener), không clone, không xoá.
 */
(function () {
  'use strict';

  var ICONS = {
    award: '<circle cx="12" cy="9" r="5.5"/><path d="m9.6 8.9 1.6 1.6 3.3-3.3"/><path d="M8.6 13.7 7 21l5-2.6 5 2.6-1.6-7.3"/>',
    box: '<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/><path d="m7.8 5.3 8.5 4.5"/>',
    support: '<path d="M4 13v-1a8 8 0 0 1 16 0v1"/><rect x="3" y="13" width="4" height="6" rx="1.5"/><rect x="17" y="13" width="4" height="6" rx="1.5"/><path d="M19 19c0 1.5-1.5 2.5-4 2.5h-2"/>',
    shield: '<path d="M12 3 5 6v5.5c0 4.4 3 8.2 7 9.5 4-1.3 7-5.1 7-9.5V6z"/><path d="m9 12 2.2 2.2L15.5 10"/>',
    ticket: '<path d="M3.5 8.5a2 2 0 0 0 0 7V18h17v-2.5a2 2 0 0 1 0-7V6h-17z"/><path d="M14 6v12" stroke-dasharray="2 2"/>',
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>',
    chev: '<path d="m6 9 6 6 6-6"/>'
  };
  var EMOJI_LEAD = /^[\s☀-➿️‍]*(?:[\uD83C-\uD83E][\uDC00-\uDFFF][\s️‍]*)*/;

  function svg(name) {
    return '<svg class="sxs-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICONS[name] + '</svg>';
  }

  function stripLeadEmoji(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) {
        n.nodeValue = n.nodeValue.replace(EMOJI_LEAD, '');
        if (n.nodeValue) return;
      } else if (n.nodeType === 1 && n.tagName !== 'B' && n.tagName !== 'STRONG') {
        if (!n.querySelector('svg') && !n.textContent.trim()) continue;
        return;
      } else {
        return;
      }
    }
  }

  function readData() {
    var el = document.getElementById('sxs-data');
    if (!el) return { offers: [], labels: {} };
    try { return JSON.parse(el.textContent); } catch (e) { return { offers: [], labels: {} }; }
  }

  function money(cents, tpl) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (tpl || '฿{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function skin(root, data) {
    if (root.__sxs) return;
    var modal = root.querySelector('.sey-xpc__modal');
    var formCol = root.querySelector('.sey-xpc__form-col');
    var sumCol = root.querySelector('.sey-xpc__sum-col');
    var sumCard = root.querySelector('.sey-xpc__sum-card');
    if (!modal || !formCol || !sumCol || !sumCard) return;
    root.__sxs = true;
    root.classList.add('sxs');
    var L = data.labels || {};

    /* 1. Icon nét thay emoji */
    var badgeIcons = ['award', 'box', 'support'];
    Array.prototype.forEach.call(root.querySelectorAll('.sey-xpc__badge-ico'), function (el, i) {
      el.innerHTML = svg(badgeIcons[i] || 'award');
    });
    Array.prototype.forEach.call(root.querySelectorAll('.sey-xpc__notice'), function (el) {
      stripLeadEmoji(el);
      el.insertAdjacentHTML('afterbegin', svg('shield'));
    });
    Array.prototype.forEach.call(root.querySelectorAll('.sey-xpc__coupon-ic'), function (el) {
      el.innerHTML = svg('ticket');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-xpc-coupon-pill] > span'), function (el) {
      stripLeadEmoji(el);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.sey-xpc__secure'), function (el) {
      stripLeadEmoji(el);
      el.insertAdjacentHTML('afterbegin', svg('lock'));
    });

    /* 2. Cột phải: gom mốc quà + upsell vào một khối đặt SAU thẻ đơn hàng */
    var after = document.createElement('div');
    after.className = 'sxs-after';
    var reward = sumCol.querySelector('.sey-xpc__reward');
    sumCol.appendChild(after);
    if (reward) after.appendChild(reward);

    var upsell = buildUpsell(root, data);
    if (upsell) after.appendChild(upsell);

    /* 3. Điện thoại: thanh tóm tắt + khung mã/tổng trên nút đặt */
    var sumbar = document.createElement('button');
    sumbar.type = 'button';
    sumbar.className = 'sxs-sumbar';
    sumbar.setAttribute('aria-expanded', 'false');
    sumbar.innerHTML =
      '<span class="sxs-sumbar__lead">' + (L.summary || 'ข้อมูลคำสั่งซื้อ') +
      ' <small data-sxs-count></small>' + svg('chev').replace('sxs-ico', 'sxs-ico sxs-sumbar__chev') + '</span>' +
      '<span class="sxs-sumbar__total"><small>THB</small><span data-sxs-total></span></span>';
    modal.insertBefore(sumbar, modal.firstChild);
    sumbar.addEventListener('click', function () {
      var open = root.classList.toggle('sxs-sum-open');
      sumbar.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    var mobileSubmit = formCol.querySelector('.sey-xpc__mobile-submit');
    var paycard = document.createElement('div');
    paycard.className = 'sey-xpc__card sxs-paycard';
    paycard.innerHTML =
      '<div class="sxs-paycard__slot"></div>' +
      '<div class="sxs-paycard__total"><span class="sxs-paycard__thumbs" data-sxs-thumbs></span>' +
      '<span class="sxs-paycard__label">' + (L.total || 'รวมทั้งหมด') + '<small data-sxs-count></small></span>' +
      '<span class="sxs-paycard__amount"><small>THB</small><span data-sxs-total></span></span></div>';
    if (mobileSubmit) formCol.insertBefore(paycard, mobileSubmit);
    else formCol.appendChild(paycard);

    /* Di chuyển node của app theo kích thước màn hình — có mốc để trả về chỗ cũ */
    var coupon = sumCard.querySelector('.sey-xpc__coupon');
    var couponHome = coupon ? document.createComment('sxs-coupon-home') : null;
    if (coupon) coupon.parentNode.insertBefore(couponHome, coupon);
    var afterHome = document.createComment('sxs-after-home');
    sumCol.insertBefore(afterHome, after);

    var mq = window.matchMedia('(max-width: 767px)');
    function arrange() {
      if (mq.matches) {
        if (coupon) paycard.querySelector('.sxs-paycard__slot').appendChild(coupon);
        var anchor = mobileSubmit ? mobileSubmit.nextSibling : null;
        formCol.insertBefore(after, anchor);
      } else {
        if (coupon && couponHome.parentNode) couponHome.parentNode.insertBefore(coupon, couponHome.nextSibling);
        if (afterHome.parentNode) afterHome.parentNode.insertBefore(after, afterHome.nextSibling);
      }
    }
    arrange();
    if (mq.addEventListener) mq.addEventListener('change', arrange);
    else if (mq.addListener) mq.addListener(arrange);

    /* 4. Đồng bộ tổng tiền / số món / ảnh nhỏ / danh sách upsell theo DOM app đã render */
    var pending = false;
    function sync() {
      pending = false;
      var totalEl = root.querySelector('[data-xpc-total]');
      var totalText = totalEl ? totalEl.textContent.trim() : '';
      var lines = root.querySelectorAll('[data-xpc-items] [data-xpc-line-variant]');
      var count = 0;
      var inCart = {};
      Array.prototype.forEach.call(lines, function (row) {
        count += parseInt(row.getAttribute('data-xpc-line-qty'), 10) || 0;
        inCart[row.getAttribute('data-xpc-line-variant')] = true;
      });
      var countText = count > 0 ? (L.items || '[n] ชิ้น').replace('[n]', count) : '';
      // Popup vừa mở, app chưa đọc xong giỏ → chưa có dòng nào: để trống thay vì hiện "฿0"
      if (!lines.length) totalText = '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-sxs-total]'), function (el) {
        if (el.textContent !== totalText) el.textContent = totalText;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-sxs-count]'), function (el) {
        var t = countText ? '(' + countText + ')' : '';
        if (el.closest('.sxs-paycard')) t = countText;
        if (el.textContent !== t) el.textContent = t;
      });
      var thumbs = root.querySelector('[data-sxs-thumbs]');
      if (thumbs) {
        var srcs = Array.prototype.slice.call(root.querySelectorAll('[data-xpc-items] .sey-xpc__li-media img'), 0, 3)
          .map(function (img) { return img.getAttribute('src'); });
        var key = srcs.join('|');
        if (thumbs.getAttribute('data-key') !== key) {
          thumbs.setAttribute('data-key', key);
          thumbs.innerHTML = srcs.map(function (s) { return '<img src="' + s + '" alt="" loading="lazy">'; }).join('');
        }
      }
      if (upsell) refreshUpsell(upsell, inCart, data);
    }
    // setTimeout thay vì requestAnimationFrame: rAF bị hoãn khi tab ẩn → danh sách upsell
    // có thể lệch với giỏ và khách bấm thêm trùng món đã có.
    function queue() {
      if (pending) return;
      pending = true;
      setTimeout(sync, 0);
    }
    new MutationObserver(queue).observe(sumCard, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-xpc-line-qty'] });
    sync();
  }

  /* ─── Upsell "ข้อเสนอพิเศษสำหรับคุณ" ───────────────────────────────────── */

  function buildUpsell(root, data) {
    var offers = data.offers || [];
    if (!offers.length) return null;
    var L = data.labels || {};
    var box = document.createElement('div');
    box.className = 'sxs-upsell';
    box.innerHTML = '<p class="sxs-upsell__title">' + (L.upsell || 'ข้อเสนอพิเศษสำหรับคุณ') + '</p><ul class="sxs-upsell__track" role="list"></ul>';
    var track = box.querySelector('.sxs-upsell__track');

    offers.forEach(function (o) {
      var li = document.createElement('li');
      li.className = 'sxs-offer';
      li.setAttribute('data-variant', o.variant);
      li.innerHTML =
        (o.image ? '<img class="sxs-offer__img" src="' + o.image + '" alt="" loading="lazy">' : '') +
        '<a class="sxs-offer__name" href="' + o.url + '" target="_blank" rel="noopener"></a>' +
        (o.compare > o.price ? '<s class="sxs-offer__was">' + money(o.compare, data.money) + '</s>' : '') +
        '<span class="sxs-offer__now' + (o.compare > o.price ? ' is-sale' : '') + '">' + money(o.price, data.money) + '</span>' +
        '<button type="button" class="sxs-offer__add">' + (L.add || 'เพิ่ม') + '</button>';
      li.querySelector('.sxs-offer__name').textContent = o.title;
      li.querySelector('.sxs-offer__add').addEventListener('click', function (e) {
        e.currentTarget.__sxsRoot = root;
        // Chặn thêm trùng: món đã nằm trong giỏ (app đã vẽ dòng) thì không cộng số lượng
        if (root.querySelector('[data-xpc-items] [data-xpc-line-variant="' + o.variant + '"]')) {
          li.hidden = true;
          return;
        }
        addOffer(e.currentTarget, o, L);
      });
      track.appendChild(li);
    });
    box.__limit = data.limit || 4;
    return box;
  }

  function refreshUpsell(box, inCart, data) {
    var shown = 0;
    Array.prototype.forEach.call(box.querySelectorAll('.sxs-offer'), function (li) {
      var hide = !!inCart[li.getAttribute('data-variant')] || shown >= box.__limit;
      li.hidden = hide;
      if (!hide) shown += 1;
    });
    box.hidden = shown === 0;
  }

  function addOffer(btn, offer, L) {
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = L.adding || 'กำลังเพิ่ม…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: offer.variant, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function () {
        btn.textContent = L.added || 'เพิ่มแล้ว';
        openPopup(btn.__sxsRoot || activeRoot());
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        window.alert(L.error || 'เพิ่มสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง');
      });
  }

  /* Popup đang chạy: section cũ trong theme nếu có (app tự nhường cho nó), không thì app block */
  function activeRoot() {
    var legacy = document.querySelector('.sey-xpc:not([data-sey-xpc])');
    if (legacy) return legacy.querySelector('.sey-xpc__modal') ? legacy : null;
    var app = document.querySelector('[data-sey-xpc]');
    return app && app.querySelector('.sey-xpc__modal') ? app : null;
  }

  /* Mở (hoặc mở lại) popup qua đúng cổng popup đó lắng nghe: click lên phần tử khớp
     trigger_selector của nó. openModal() đọc lại /cart.js, tính lại ship/voucher/quà. */
  function openPopup(root) {
    if (!root) return false;
    var sel = (root.getAttribute('data-trigger-selector') || '').trim();
    if (!sel) return false;
    if (sel.indexOf('[data-cart-checkout]') !== -1) {
      var trigger = document.getElementById('sxs-resync');
      if (!trigger) {
        trigger = document.createElement('span');
        trigger.id = 'sxs-resync';
        trigger.setAttribute('data-cart-checkout', '');
        trigger.hidden = true;
        document.body.appendChild(trigger);
      }
      trigger.click();
      return true;
    }
    var el = document.querySelector(sel);
    if (!el) return false;
    el.click();
    return true;
  }

  /* ─── Bỏ bước xem giỏ: link /cart → mở thẳng popup thanh toán ─────────── */

  function cartCount() {
    var el = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count, .cart-count-bubble span');
    if (!el) return -1;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? -1 : n;
  }

  function isCartLink(a) {
    if (!a || a.tagName !== 'A' || !a.getAttribute('href')) return false;
    if (a.closest('.sey-xpc')) return false;
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      return u.origin === location.origin && u.pathname.replace(/\/$/, '') === '/cart' && !u.search;
    } catch (e) { return false; }
  }

  function bindSkipCart(data) {
    if (data.keepCartView) return;
    document.documentElement.classList.add('sxs-skip-cart');
    window.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!isCartLink(a)) return;
      if (cartCount() === 0) return; // giỏ trống: cho vào /cart để thấy gợi ý mua
      var root = activeRoot();
      if (!root) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // Đóng toast "เพิ่มสินค้าเข้าตะกร้าแล้ว" và mini-cart nếu đang mở, tránh 2 lớp chồng nhau
      var toastClose = document.querySelector('.seyoul-ast__close');
      if (toastClose && toastClose.offsetParent) toastClose.click();
      var mcClose = document.getElementById('seyoul-mc-close');
      if (mcClose && mcClose.offsetParent) mcClose.click();
      openPopup(root);
    }, true);

    // Đổi chữ nút trong toast thêm giỏ: "ดูตะกร้าสินค้า" → "ชำระเงิน" (nút giờ mở thanh toán)
    var label = (data.labels && data.labels.checkout) || 'ชำระเงิน';
    function relabel() {
      Array.prototype.forEach.call(document.querySelectorAll('.seyoul-ast__view-cart'), function (btn) {
        if (btn.__sxsLabel) return;
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
        for (var n = walker.nextNode(); n; n = walker.nextNode()) {
          if (/ตะกร้า/.test(n.nodeValue)) {
            n.nodeValue = n.nodeValue.replace(/\S.*\S|\S/, label);
            btn.__sxsLabel = true;
            break;
          }
        }
      });
    }
    relabel();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; relabel(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ─── Khởi động ─────────────────────────────────────────────────────── */

  var DATA = null;

  function boot() {
    if (!DATA) DATA = readData();
    var roots = document.querySelectorAll('.sey-xpc');
    var any = false;
    Array.prototype.forEach.call(roots, function (r) {
      if (r.querySelector('.sey-xpc__modal')) { skin(r, DATA); any = true; }
    });
    if (any && !window.__sxsSkipCart) {
      window.__sxsSkipCart = true;
      bindSkipCart(DATA);
    }
    return any && !!activeRoot();
  }

  function start() {
    if (boot()) return;
    var obs = new MutationObserver(function () { if (boot()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
